import Vue from "vue";
import Vuex from "vuex";
import {
  LoadUser,
  SaveStatePlugin,
  LoadLang,
  LoadCookie,
  GetSession,
  RemoveSession,
} from "./services/localstate";
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [SaveStatePlugin],
  state: {
    user: {},
    jwt: "",
    lang: "",
  },
  mutations: {
    UPDATE_USER(state, user) {
      state.user = user;
    },
    UPDATE_BKG(state, f) {
      state.user.bkgimage = f;
    },
    LOGOUT_USER(state) {
      state.user = null;
      state.jwt = null;
    },
    initialiseStore(state) {
      state.user = LoadUser();
      state.lang = LoadLang();
    },
    SET_LANG(state, lang) {
      state.lang = lang;
    },
  },
  actions: {
    logout({ commit }) {
      commit("LOGOUT_USER");
      RemoveSession();
    },
    setLang({ commit }, lang) {
      commit("SET_LANG", lang);
    },
  },
  getters: {
    jwt: (state) => {
      if (state.user) {
        return state.user.jwt;
      } else {
        return "NA";
      }
    },
  },
});
